import gsap from 'gsap';
import { Container, Sprite } from 'src/game/minigame/match2-timestep/odie';

export default class Lotus extends Container {
  private _transformView = new Container();
  private _timeline: gsap.core.Timeline;
  private _leaves: Sprite;
  private _flower: Sprite;

  constructor(parent: Container) {
    super();
    parent.addChild(this._transformView);
    this._transformView.addChild(this);
    this._transformView.scaleX = this._transformView.scaleY = 0.8;
    this._leaves = Sprite.from('fx.pond/fx.pond.lotus.leaf.png');
    this._flower = Sprite.from('fx.pond/fx.pond.lotus.flower.png');
    this._leaves.anchorX = this._leaves.anchorY = 0.5;
    this._flower.anchorX = this._flower.anchorY = 0.5;
    this._flower.x = 10;
    this._flower.y = 4;
    this.addChild(this._leaves);
    this.addChild(this._flower);

    const animateX = 2;
    const animateY = 2;
    const rotate = 0.1;
    const signX = Math.random() > 0.5 ? 1 : -1;
    const signY = Math.random() > 0.5 ? 1 : -1;
    const signRotate = Math.random() > 0.5 ? 1 : -1;

    this._transformView.x = -animateX * signX;
    this._transformView.y = -animateY * signY;
    this._transformView.rotation = -rotate * signRotate;

    this._timeline = gsap
      .timeline()
      .to(this._transformView, {
        duration: 4,
        x: animateX * signX,
        ease: 'quad.inOut',
        repeat: -1,
        yoyo: true,
        delay: Math.random() * 0.5,
      })
      .to(
        this._transformView,
        {
          duration: 5,
          y: animateY * signY,
          ease: 'quad.inOut',
          repeat: -1,
          yoyo: true,
          delay: Math.random() * 0.5,
        },
        0,
      )
      .to(
        this._transformView,
        {
          duration: 4,
          rotation: rotate * signRotate,
          ease: 'quad.inOut',
          repeat: -1,
          yoyo: true,
        },
        0,
      );

    this._timeline.seek(Math.random() * this._timeline.duration());
  }

  public remove() {
    this._timeline.kill();
    this.removeFromParent();
  }

  public async show(animated = false) {
    gsap.killTweensOf(this._flower);

    if (!animated) {
      this._flower.scaleX = this._flower.scaleY = 1;
      return;
    }

    this._flower.scaleX = this._flower.scaleY = 0;
    await gsap.to(this._flower, {
      duration: 0.4,
      scaleX: 1,
      scaleY: 1,
      ease: 'back.in(5)',
    });
  }

  public async hide(animated = false) {
    gsap.killTweensOf(this._flower);

    if (!animated) {
      this._flower.scaleX = this._flower.scaleY = 0;
      return;
    }

    this._flower.scaleX = this._flower.scaleY = 1;
    await gsap.to(this._flower, {
      duration: 0.4,
      scaleX: 0,
      scaleY: 0,
      ease: 'back.in(5)',
    });

    // do not wait for the lotus fade out
    gsap.to(this._transformView, {
      duration: 0.75,
      alpha: 0,
      scaleX: 0.65,
      scaleY: 0.65,
      ease: 'quad.inOut',
      onComplete: () => {
        this._timeline.kill();
      },
    });
  }
}
